module.exports = __webpack_public_path__ + "img/cupping.66c6f711.png";